export const loginConfig = {
  useNewLoadingPage: true,
};
